export var AUTH_ACTIONS = '/auth-actions';
export var FORGOT_PASSWORD = '/forgot-password';
export var LOGIN = '/login';
export var LOGOUT = '/logout';
export var REGISTER = '/register';
